export enum EFooterMenuCategory {
  QUICKCODES = 'QuickCodes',
  PRODUCT = 'Product',
  LEGAL = 'Legal',
}
